import { IAppState } from '../app.state';
import { createSelector } from '@ngrx/store';
import { IPersonasState } from '../state/personas.state';

export const selectPersonasList = createSelector(
    (state: IAppState) => state.personas,
    (state: IPersonasState) => state.personas
);
